
export default function UnderstandingQuestionnaires() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Understanding Cyber Insurance Questionnaires
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#e10708] to-[#c00607] mx-auto mb-6"></div>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-red-50 rounded-2xl p-10 border border-gray-200">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-800 leading-relaxed mb-6">
              A cyber insurance questionnaire is designed to evaluate an organization's <strong>security maturity</strong>, <strong>risk exposure</strong>, and overall <strong>eligibility for coverage</strong>. Insurers use these responses to determine policy approval, coverage limits, exclusions, and premiums.
            </p>
            
            <p className="text-gray-800 leading-relaxed mb-6">
              Most questionnaires place heavy emphasis on <strong>identity protection</strong>, <strong>ransomware resilience</strong>, <strong>employee behavior</strong>, and <strong>incident readiness</strong>.
            </p>

            <div className="bg-red-50 border-l-4 border-red-600 p-6 rounded-lg mt-8">
              <div className="flex items-start gap-4">
                <i className="ri-error-warning-line text-3xl text-red-600 flex-shrink-0"></i>
                <div>
                  <h3 className="text-xl font-bold text-red-900 mb-2">Critical Warning</h3>
                  <p className="text-red-800 leading-relaxed">
                    Providing accurate and truthful answers is critical—<strong>misstatements or outdated controls can result in coverage limitations or claim denial</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}